import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const BRAND_BLUE = "#00336C";

export default function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Delete Item",
  description = "Are you sure you want to delete this item? This action can't be undone.",
  confirmLabel = "Delete",
  confirmingLabel = "Deleting…",
  cancelLabel = "Cancel",
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose?.()}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 24px 48px rgba(0,51,108,0.22)",
        },
      }}
    >
      <DialogContent
        sx={{
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          px: 4,
          pt: 4.5,
          pb: 3,
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "#FEE4E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DeleteIcon sx={{ color: "#D92D20", fontSize: 28 }} />
        </Box>
        <Typography sx={{ color: BRAND_BLUE, fontWeight: 800, fontSize: "1.15rem" }}>
          {title}
        </Typography>
        <Typography sx={{ color: "#667085", fontSize: "0.925rem", lineHeight: 1.5 }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#fff",
          px: 4,
          pb: 4,
          pt: 0.5,
          gap: 1.5,
        }}
      >
        <Button
          fullWidth
          onClick={onClose}
          disabled={loading}
          sx={{
            color: BRAND_BLUE,
            fontWeight: 700,
            borderRadius: "10px",
            border: "1px solid rgba(0,51,108,0.18)",
            py: 1,
            "&:hover": { backgroundColor: "rgba(0,51,108,0.06)", border: "1px solid rgba(0,51,108,0.18)" },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          sx={{
            backgroundColor: "#D92D20",
            borderRadius: "10px",
            boxShadow: "0 8px 18px rgba(217,45,32,0.22)",
            fontWeight: 800,
            py: 1,
            "&:hover": { backgroundColor: "#B42318", boxShadow: "0 10px 22px rgba(217,45,32,0.28)" },
            "&.Mui-disabled": { backgroundColor: "rgba(217,45,32,0.42)", color: "#fff" },
          }}
        >
          {loading ? confirmingLabel : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
